export default "__VITE_ASSET__DGGRVmq9__"